import { toastr } from 'react-redux-toastr';
import { ITINERARY_SERVICE_TYPE, POLICY_NUMBER } from '../../config/constants';
import { BASE_PRINT_AGENT_URL } from '../../config/endpoints';
import {
  DATE_TIME_FORMAT,
  DATE_FORMAT,
  TIME_FORMAT,
} from '../../config/locale';
import { tzNormalizeDate } from '../date';
import { numberFormatter } from '../number';
import {
  addQrCode,
  addText,
  createPdfDocument,
  paragraphSize,
  setFont,
  y,
} from '../pdf';
import {
  printSaleVoucher,
  addSaleVoucherCopies,
  pageWidth as totalPosPageWidth,
  pageHeight as totalPosPageHeight,
  pageHeightQr as totalPosPageHeightQr,
} from './TotalPosSale';

const myX = 3;
let myY = y;
const margin = 3;

const preFooter =
  'Autorizado mediante Resolución de Intendencia: Número 0180050002242/SUNAT Para mayor información sobre todos los términos y condiciones puede ingresar a la página web: http://www.civa.com.pe';

const qrWidth = 35;
const qrHeight = 35;

const printLine = (doc, factor = 1) => {
  addText(
    doc,
    '----------------------------------------------------------------------------',
    40,
    (myY += margin * factor),
    80,
  );
};

const printCompanyFields = (doc) => {
  doc.setFontSize(12);

  setFont(doc, 'bold');
  addText(doc, 'TURISMO CIVA S.A.C.', 40, myY, 80);
  setFont(doc);
  addText(doc, 'Si va de viaje, ¡viaje en Civa!', 40, (myY += margin + 2), 80);
  addText(doc, 'R.U.C 20102427891', 40, (myY += margin + 2), 80);
  addText(doc, 'JR SANCHO DE RIVERA 1184', 40, (myY += margin + 2), 80);
  addText(doc, 'URB. MONSERRATE LIMA', 40, (myY += margin + 2), 80);
  addText(
    doc,
    'Central Telefónica: (511) 418-1111',
    40,
    (myY += margin + 2),
    80,
  );
  doc.setFontSize(paragraphSize);
  printLine(doc);
  doc.setFontSize(12);
};

const printTicketFields = (
  doc,
  { issuingAgency, createDate, voucherType, ticketCode },
) => {
  const agencyName = doc.splitTextToSize(
    `Agencia de Emisión: ${issuingAgency}`,
    75,
  );
  addText(doc, agencyName, myX, (myY += margin), 75, 'left');
  addText(
    doc,
    `Fecha/Hora Emisión: ${createDate}`,
    myX,
    (myY += margin + 5 * agencyName.length + 0.3),
    75,
    'left',
  );
  setFont(doc, 'bold');
  doc.setFontSize(14);
  myY += 2;

  const voucherText = doc.splitTextToSize(voucherType.toUpperCase(), 75);
  addText(doc, voucherText, 40, (myY += margin), 75);

  addText(doc, ticketCode, 40, (myY += 5.5 * voucherText.length), 75);
  doc.setFontSize(paragraphSize);
  setFont(doc);
  printLine(doc);
  doc.setFontSize(12);
};

const printTripFields = (
  doc,
  {
    origin,
    boarding,
    boardingAddress,
    disembarking,
    destination,
    disembarkingAddress,
    tripDate,
    tripTime,
    seatNumber,
    floor,
    serviceType,
    serviceTypeId,
    foodType = '',
  },
) => {
  let newFoodType = foodType;

  // Only EXCLUCIVA service type has food
  if (serviceTypeId !== ITINERARY_SERVICE_TYPE.EXCLUCIVA.value) {
    newFoodType = 'Sin alimentación';
  }

  setFont(doc, 'bold');
  addText(doc, 'DATOS DE VIAJE:', myX, (myY += margin * 2), 75, 'left');

  setFont(doc);
  addText(doc, 'Origen', myX, (myY += margin + 2), 30, 'left');
  addText(doc, `: ${origin}`, 23, myY, 55, 'left');

  setFont(doc, 'bold');
  addText(doc, 'Embarque: ', myX, (myY += margin + 3), 30, 'left');
  addText(doc, `${boarding}`, myX, (myY += margin + 2), 70, 'left');
  const newBoardingAddress = doc.splitTextToSize(boardingAddress, 70);
  addText(doc, newBoardingAddress, myX, (myY += margin + 3), 70, 'left');

  setFont(doc);
  addText(
    doc,
    'Destino',
    myX,
    (myY += margin * newBoardingAddress.length + 3),
    30,
    'left',
  );
  addText(doc, `: ${destination}`, 23, myY, 55, 'left');

  setFont(doc, 'bold');
  addText(doc, 'Desembarque: ', myX, (myY += margin + 6), 32, 'left');
  addText(doc, `${disembarking}`, myX, (myY += margin + 2), 70, 'left');
  const newDisembarkingAddress = doc.splitTextToSize(disembarkingAddress, 70);
  addText(doc, newDisembarkingAddress, myX, (myY += margin + 3), 70, 'left');

  setFont(doc);
  addText(
    doc,
    'Fecha',
    myX,
    (myY += margin * newDisembarkingAddress.length + margin * 2),
    15,
    'left',
  );
  addText(doc, `: ${tripDate}`, 15, myY, 25, 'left');

  addText(doc, 'Hora', 42, myY, 15, 'left');
  addText(doc, `: ${tripTime}`, 52, myY, 25, 'left');

  addText(doc, 'Asiento', myX, (myY += margin + 2), 15, 'left');
  addText(doc, `: ${seatNumber}`, 18, myY, 25, 'left');

  addText(doc, 'Piso', 42, myY, 15, 'left');
  addText(doc, `: ${floor}`, 52, myY, 25, 'left');

  addText(doc, 'Servicio', myX, (myY += margin + 2), 15, 'left');
  addText(doc, `: ${serviceType}`, 18, myY, 80, 'left');

  addText(doc, 'Alimentacion', myX, (myY += margin + 2), 30, 'left');
  addText(doc, `: ${newFoodType}`, 28, myY, 25, 'left');

  myY += margin * 3;

  setFont(doc, 'bold');
  doc.setFontSize(13);
  addText(doc, '*Presentarse 45 minutos antes', 40, myY, 80);
  doc.setFontSize(paragraphSize);
  setFont(doc);
  printLine(doc);
};
const printPassengerFields = (
  doc,
  { fullName, identificationType, idDocumentNumber },
) => {
  const maxWidth = 75;
  const lineHeight = 4; // más compacto que antes
  const compactMargin = 1; // menos espacio entre bloques
  doc.setFontSize(12);

  setFont(doc, 'bold');
  myY += margin * 1.5; // título con espacio
  addText(doc, 'DATOS DEL PASAJERO:', myX, myY, maxWidth, 'left');

  setFont(doc);

  // Nombre
  const nameLines = doc.splitTextToSize(`Nombre: ${fullName}`, maxWidth);
  myY += compactMargin + 3;
  doc.text(nameLines, myX, myY);
  myY += nameLines.length * lineHeight;

  // Tipo Documento
  const typeLines = doc.splitTextToSize(
    `Tipo Documento: ${identificationType}`,
    maxWidth,
  );
  myY += compactMargin + 2;
  doc.text(typeLines, myX, myY);
  myY += typeLines.length * lineHeight;

  // Número de Documento
  const numberLines = doc.splitTextToSize(
    `Numero de Documento: ${idDocumentNumber}`,
    maxWidth,
  );
  myY += compactMargin + 1;
  doc.text(numberLines, myX, myY);
  myY += numberLines.length * lineHeight;

  doc.setFontSize(paragraphSize);
  printLine(doc);
  doc.setFontSize(12);
};

const printPaymentFields = (
  doc,
  { ticketPrice, ticketPriceString, paymentMethod, userName, proratedPayments },
) => {
  setFont(doc, 'bold');
  addText(doc, 'DATOS DE PAGO:', myX, (myY += margin * 2), 75, 'left');
  setFont(doc);
  addText(doc, 'OP. GRATUITO', myX, (myY += margin + 2), 75, 'left');
  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 34, myY);
  addText(doc, 'OP. EXONERADO', myX, (myY += margin + 2), 75, 'left');
  addText(doc, `: ${numberFormatter({ value: ticketPrice })}`, myX + 34, myY);
  addText(doc, 'OP. INAFECTO', myX, (myY += margin + 2), 75, 'left');
  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 34, myY);
  addText(doc, 'IGV', myX, (myY += margin + 2), 75, 'left');
  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 34, myY);
  addText(doc, 'IMPORTE TOTAL A PAGAR', myX, (myY += margin + 2), 80, 'left');
  addText(doc, numberFormatter({ value: ticketPrice }), myX + 50, myY);
  addText(doc, 'Son:', myX, (myY += margin + 2), 10, 'left');
  const newTicketPriceString = doc.splitTextToSize(ticketPriceString, 50);
  addText(doc, newTicketPriceString, myX + 10, myY, 50, 'left');

  addText(
    doc,
    'Tipo de Pago',
    myX,
    (myY += margin * newTicketPriceString.length + 3),
    75,
    'left',
  );
  addText(doc, ':', myX + 34, myY);

  const isMultiPayment =
    Array.isArray(proratedPayments) && proratedPayments.length > 1;

  if (isMultiPayment) {
    proratedPayments.forEach((payment) => {
      const methodLines = doc.splitTextToSize(payment.paymentMethodName, 33);
      addText(doc, methodLines, myX, (myY += margin + 1), 44, 'left');
      addText(
        doc,
        `: ${numberFormatter({ value: payment.amount })}`,
        myX + 34,
        myY,
      );
      if (methodLines.length > 1) {
        myY += margin * (methodLines.length - 1);
      }
    });
    myY += margin + 3;
  } else {
    const newPaymentMethod = doc.splitTextToSize(paymentMethod, 40);
    addText(doc, newPaymentMethod, myX + 36, myY, 40, 'left');
    myY += margin * newPaymentMethod.length + 3;
  }

  addText(doc, 'Numero Tarjeta', myX, myY, 75, 'left');
  addText(doc, `: -`, myX + 34, myY);
  addText(doc, 'Numero Voucher', myX, (myY += margin + 2), 75, 'left');
  addText(doc, `: -`, myX + 34, myY);
  addText(doc, 'Usuario', myX, (myY += margin + 2), 75, 'left');
  addText(doc, ':', myX + 34, myY);
  const newUserName = doc.splitTextToSize(userName, 40);
  addText(doc, newUserName, myX + 36, myY, 40, 'left');

  setFont(doc, 'bold');
  doc.setFontSize(14);
  myY +=
    newUserName.length * margin * 2 + (8 - newUserName.length * margin + 2);
  addText(doc, 'Asegurado con La Positiva Seguros y Reaseguros', 40, myY, 80);
  addText(doc, `POLIZA ${POLICY_NUMBER}`, 40, (myY += 11.5), 80);
  doc.setFontSize(10);
  addText(doc, preFooter, myX, (myY += margin * 2), 74, 'justify');
  doc.setFontSize(paragraphSize);
};

const printBusinessFields = (doc, { companyDocumentNumber, companyName }) => {
  setFont(doc, 'bold');
  addText(doc, 'DATOS DEL CLIENTE:', myX, (myY += margin * 2), 75, 'left');
  setFont(doc);
  addText(
    doc,
    `RUC: ${companyDocumentNumber}`,
    myX,
    (myY += margin + 2),
    75,
    'left',
  );
  const newCompanyName = doc.splitTextToSize(companyName, 75);
  addText(doc, newCompanyName, myX, (myY += margin + 2), 75, 'left');
  doc.setFontSize(paragraphSize);
  printLine(doc, newCompanyName.length + 1);
  doc.setFontSize(12);
};

const printOperationDetails = (
  doc,
  {
    createDate,
    ticketCode,
    ticketPrice,
    voucherType,
    paymentMethod,
    userName,
    proratedPayments,
  },
) => {
  myY = 20;
  doc.addPage('p', 'mm', [80, 40]);
  setFont(doc, 'bold');
  addText(doc, 'Detalle de Operación', myX, (myY += margin), 75, 'left');
  setFont(doc);
  printLine(doc);
  addText(
    doc,
    `Fecha/Hora Emisión : ${createDate}`,
    myX,
    (myY += margin),
    75,
    'left',
  );
  addText(
    doc,
    `${voucherType} : ${ticketCode}`,
    myX,
    (myY += margin),
    75,
    'left',
  );

  const isMultiPayment =
    Array.isArray(proratedPayments) && proratedPayments.length > 1;

  if (isMultiPayment) {
    addText(doc, 'Tipo Pago :', myX, (myY += margin), 75, 'left');
    proratedPayments.forEach((payment) => {
      const methodLines = doc.splitTextToSize(payment.paymentMethodName, 44);
      addText(doc, methodLines, myX, (myY += margin), 44, 'left');
      addText(doc, numberFormatter({ value: payment.amount }), myX + 50, myY);
      if (methodLines.length > 1) {
        myY += margin * (methodLines.length - 1);
      }
    });
  } else {
    addText(
      doc,
      `Tipo Pago : ${paymentMethod}`,
      myX,
      (myY += margin),
      75,
      'left',
    );
  }

  addText(
    doc,
    `IMPORTE TOTAL A PAGAR : ${numberFormatter({ value: ticketPrice })}`,
    myX,
    (myY += margin),
  );
  addText(doc, `Usuario : ${userName}`, myX, (myY += margin));
};

// appends an extra OpenPay by BBVA (TotalPos) sale voucher page to the
// ticket's own document — only called when the ticket data carries a
// totalPos sale response, so it ships as part of the same PDF/print job
// as the ticket instead of a separate popup competing for the browser's
// popup-blocker allowance
const printTotalPosSalePage = (doc, { response, isQrPayment }) => {
  doc.addPage(isQrPayment ? 'l' : 'p', 'mm', [
    totalPosPageWidth,
    isQrPayment ? totalPosPageHeightQr : totalPosPageHeight,
  ]);
  printSaleVoucher(doc, response, isQrPayment);
};

const addTicket = async (
  doc,
  {
    proratedPayments,
    ticketFields: { issuingAgency, createDate, voucherType, ticketCode },
    tripFields: {
      origin,
      boarding,
      boardingAddress,
      disembarking,
      destination,
      disembarkingAddress,
      tripDate,
      tripTime,
      seatNumber,
      floor,
      serviceTypeId,
      serviceType,
      foodType = '',
    },
    passengerFields: { fullName, identificationType, idDocumentNumber },
    paymentFields: {
      ticketPrice,
      ticketPriceString,
      paymentMethod,
      userName,
      companyDocumentNumber = null,
      companyName = null,
    },
    // optional: only present when the ticket was actually paid through
    // the TotalPos pinpad — { response: <TOTALPOS_SALE response>, isQrPayment }
    totalPos = null,
  },
) => {
  await addQrCode(doc, ticketCode, 22.5, 0, qrWidth, qrHeight);
  myY += 32;
  printCompanyFields(doc);
  printTicketFields(doc, {
    issuingAgency,
    createDate,
    voucherType,
    ticketCode,
  });
  printTripFields(doc, {
    origin,
    boarding,
    boardingAddress,
    disembarking,
    destination,
    disembarkingAddress,
    tripDate,
    tripTime,
    seatNumber,
    floor,
    serviceTypeId,
    serviceType,
    foodType,
  });
  printPassengerFields(doc, {
    fullName,
    identificationType,
    idDocumentNumber,
  });
  // FACTURA
  if (companyDocumentNumber)
    printBusinessFields(doc, {
      companyDocumentNumber,
      companyName,
    });
  printPaymentFields(doc, {
    ticketPrice,
    ticketPriceString,
    paymentMethod,
    userName,
    proratedPayments,
  });
  printOperationDetails(doc, {
    createDate,
    ticketCode,
    ticketPrice,
    voucherType,
    paymentMethod,
    userName,
    proratedPayments,
  });
  if (totalPos && totalPos.response) {
    printTotalPosSalePage(doc, totalPos);
  }
  myY = 5;
};

const formatPrintedTicket = (printedTicket) => {
  const formatedPrintedTicket = {
    proratedPayments: printedTicket.proratedPayments,
    ticketFields: {
      issuingAgency: printedTicket.issuingAgency,
      createDate: printedTicket.createDate,
      voucherType: printedTicket.voucherType,
      ticketCode: printedTicket.ticketCode,
    },
    tripFields: {
      origin: printedTicket.origin,
      boarding: printedTicket.boarding,
      boardingAddress: printedTicket.boardingAddress,
      disembarking: printedTicket.disembarking,
      destination: printedTicket.destination,
      disembarkingAddress: printedTicket.disembarkingAddress,
      tripDate: printedTicket.tripDate,
      tripTime: printedTicket.tripTime,
      seatNumber: printedTicket.seatNumber,
      floor: printedTicket.floor,
      serviceType: printedTicket.serviceType,
      foodType: printedTicket.foodType,
    },
    passengerFields: {
      fullName: printedTicket.passenger.fullName,
      identificationType: printedTicket.passenger.identificationType.name,
      idDocumentNumber: printedTicket.passenger.idDocumentNumber,
    },
    paymentFields: {
      ticketPrice: printedTicket.ticketPrice,
      ticketPriceString: printedTicket.ticketPriceString,
      paymentMethod: printedTicket.paymentMethod,
      userName: printedTicket.userName,
      companyDocumentNumber: printedTicket.companyDocumentNumber,
      companyName: printedTicket.companyName,
    },
  };
  return formatedPrintedTicket;
};

function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

const printPrintedTickets = async (printedTickets) => {
  const height = 720;
  const doc = createPdfDocument('p', 'mm', [80, height]);

  // using for-of-loop for readability when using await inside a loop
  // where await is needed due to requirement of sequential steps
  // check for discussion: http://bit.ly/2JcMMLk
  // eslint-disable-next-line no-restricted-syntax
  for (const [index, printedTicket] of printedTickets.entries()) {
    if (index > 0) {
      doc.addPage('p', 'mm', [80, height]);
      myY = 5;
    }

    const formatedPrintedTicket = formatPrintedTicket(printedTicket);
    // eslint-disable-next-line no-await-in-loop
    await addTicket(doc, formatedPrintedTicket);
  }

  // one order can produce several tickets but only one pinpad payment
  // covering all of them, so the backend sends the TotalPos sale
  // response(s) just once, as `totalPosTransactions` on the first ticket
  // of the list — printed once at the end instead of duplicated per ticket.
  // items are the raw TotalPos transaction records (not wrapped), so only
  // approved sales get a voucher, and QR is derived the same way the live
  // pinpad flow does it (see MultiPaymentMethodInputGroup.js)
  const [firstTicket] = printedTickets;
  if (firstTicket) {
    addSaleVoucherCopies(doc, firstTicket.totalPosTransactions);
  }

  doc.autoPrint();

  const arrayBuffer = doc.output('arraybuffer');

  const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  const pdfBase64 = arrayBufferToBase64(arrayBuffer);

  try {
    await fetch(`${BASE_PRINT_AGENT_URL}/health`);
  } catch {
    window.open(blobUrl, '_blank');
    toastr.error(
      'Error',
      'El agente de impresión no está corriendo. Abre print-agent.exe primero.',
    );
    return;
  }

  try {
    const response = await fetch(`${BASE_PRINT_AGENT_URL}/print`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pdfBase64, printingType: 'voucher' }),
    });

    if (!response.ok) {
      const errData = await response.json();
      throw new Error(errData.error || 'Error al imprimir');
    }
  } catch (err) {
    window.open(blobUrl, '_blank');
    toastr.error('Error', err.message);
  }
};

const printPrintedTicket = async (printedTicket) => {
  const doc = createPdfDocument('p', 'mm', [80, 720]);
  const formatedPrintedTicket = formatPrintedTicket(printedTicket);
  await addTicket(doc, formatedPrintedTicket);
  doc.autoPrint();

  const arrayBuffer = doc.output('arraybuffer');

  const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  const pdfBase64 = arrayBufferToBase64(arrayBuffer);

  try {
    await fetch(`${BASE_PRINT_AGENT_URL}/health`);
  } catch {
    window.open(blobUrl, '_blank');
    toastr.error(
      'Error',
      'El agente de impresión no está corriendo. Abre print-agent.exe primero.',
    );
    return;
  }

  try {
    const response = await fetch(`${BASE_PRINT_AGENT_URL}/print`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pdfBase64, printingType: 'voucher' }),
    });

    if (!response.ok) {
      const errData = await response.json();
      throw new Error(errData.error || 'Error al imprimir');
    }
  } catch (err) {
    window.open(blobUrl, '_blank');
    toastr.error('Error', err.message);
  }
};

const formatTicket = (ticket) => {
  const transaction = ticket.transactions[0];
  const formatedTicket = {
    proratedPayments: ticket.proratedPayments,
    ticketFields: {
      issuingAgency: `${ticket.agency.name}\n${ticket.agency.address}`,
      createDate: tzNormalizeDate({
        date: ticket.documentAssignmentDate,
        format: DATE_TIME_FORMAT,
      }),
      voucherType: transaction.voucherType.name,
      ticketCode: ticket.fullDocumentCode,
    },
    tripFields: {
      origin: ticket.sourceLocation.name,
      boarding: ticket.sourceLocation.name,
      boardingAddress: ticket.sourceLocation.address,
      disembarking: ticket.destinationLocation.name,
      destination: ticket.destinationLocation.name,
      disembarkingAddress: ticket.destinationLocation.address,
      tripDate: tzNormalizeDate({
        date: ticket.departureDate,
        format: DATE_FORMAT,
      }),
      tripTime: tzNormalizeDate({
        date: ticket.departureDate,
        format: TIME_FORMAT,
      }),
      seatNumber: ticket.seatReservation
        ? ticket.seatReservation.seatNumber
        : '',
      floor: ticket.seatReservation ? ticket.seatReservation.floorNumber : '',
      serviceType: ticket.itinerary ? ticket.itinerary.serviceType.name : '',
      foodType: ticket.food ? ticket.food.name : '',
      serviceTypeId: ticket.itinerary ? ticket.itinerary.serviceType.id : '',
    },
    passengerFields: {
      fullName: ticket.customer.fullName,
      identificationType: ticket.customer.identificationType.name,
      idDocumentNumber: ticket.customer.idDocumentNumber,
    },
    paymentFields: {
      ticketPrice: ticket.salePrice,
      ticketPriceString: ticket.salePriceString,
      paymentMethod: [
        ...new Set(
          ticket.transactions.map(
            (currentTransaction) =>
              currentTransaction.paymentMethod &&
              currentTransaction.paymentMethod.name,
          ),
        ),
      ].join(' - '),
      userName: ticket.user.customer.fullName,
      companyDocumentNumber: transaction.business
        ? transaction.business.businessTaxId
        : undefined,
      companyName: transaction.business ? transaction.business.name : undefined,
    },
    // optional: only set when the ticket was paid through the TotalPos
    // pinpad — see printTotalPosSalePage
    totalPos: ticket.totalPosResponse
      ? {
          response: ticket.totalPosResponse,
          isQrPayment: ticket.isQrPayment,
        }
      : null,
  };

  return formatedTicket;
};

const printTicket = async (ticket) => {
  const doc = createPdfDocument('p', 'mm', [80, 370]);
  const formatedTicket = formatTicket(ticket);
  await addTicket(doc, formatedTicket);
  doc.autoPrint();

  const arrayBuffer = doc.output('arraybuffer');

  const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  const pdfBase64 = arrayBufferToBase64(arrayBuffer);

  try {
    await fetch(`${BASE_PRINT_AGENT_URL}/health`);
  } catch {
    window.open(blobUrl, '_blank');
    toastr.error(
      'Error',
      'El agente de impresión no está corriendo. Abre print-agent.exe primero.',
    );
    return;
  }

  try {
    const response = await fetch(`${BASE_PRINT_AGENT_URL}/print`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pdfBase64, printingType: 'voucher' }),
    });

    if (!response.ok) {
      const errData = await response.json();
      throw new Error(errData.error || 'Error al imprimir');
    }
  } catch (err) {
    window.open(blobUrl, '_blank');
    toastr.error('Error', err.message);
  }
};

export { printPrintedTickets, printPrintedTicket, printTicket };
